/*
 * AccountInvitedAcceptedDialog
 *
 * When an invitation is accepted from an email, after
 * verification steps in the router, a "type" property is
 * assigned to an account model, which is basically empty
 * since a token (hash) should never return any account
 * information to populate the model with. In some cases
 * an email is passed in the url, but we should consider.
 * that suspect, and not take any actions with it, since
 * it is meaningless in termsn of accepting the invite.
 *
 */

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-account-invite-accept.hbs';
import template_new_user from '@/../templates/dialog-account-invite-accept-new-user.hbs';
import strings from 'amdi18n-loader!@/nls/dialog_account_invite_accept';


    var AccountInvitedAcceptedDialog = Marionette.View.extend(DialogInterface).extend({
        initialize: function() {
            this.destroyOnClose();
        },
        getTemplate: function(){
            if (this.model.get('invite_type') !== 'logged_in' && this.model.get('invite_type') !== 'not_logged_in'){
                return Handlebars.compile(template_new_user);
            } else {
                return Handlebars.compile(template);
            }
        },
        templateContext: function() {
            var logged_in = false;
            var not_logged_in = false;
            var new_user = false;

            switch (this.model.get('invite_type')) {
                case 'logged_in':
                    logged_in = true;
                    break;
                case 'not_logged_in':
                    not_logged_in = true;
                    break;
                default:
                    new_user = true;
            }

            return {
                logged_in: logged_in,
                not_logged_in: not_logged_in,
                new_user: new_user,
                s: strings
            };
        }
    });

    export default AccountInvitedAcceptedDialog;

